import React from 'react';
import Home from '../Home';
import HeroImg from '../../img/ideaIntoDesign.jpg'
import Youtell from '../../img/you_tell.jpg'
import WeDesign from '../../img/we-design.jpeg'
import Youapprove from '../../img/20-Things-You-Should-Never-Say-To-A-Professional-Graphic-Designer-768x439.jpg'
// Tailwind CSS is assumed to be available
// import 'tailwindcss/tailwind.css';

// Main App Component
export default function GraphicDesign() {
  return (
    <Home>
    <div className="min-h-screen flex flex-col text-[#333] font-sans">
      {/* Header Section */}
      <header className="bg-black text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col-reverse md:flex-row items-center justify-between gap-8">
            <div className="max-w-xl text-center md:text-left">
              <p className="text-white text-sm sm:text-base font-semibold mb-2">Best Graphic Design Services</p>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight mb-4">Turns ideas into <span className="text-yellow-500">Visual Magic</span></h1>
              <p className="text-gray-400 text-sm sm:text-base leading-relaxed mb-6">
                For over a decade, SRK Softwares has been a leading graphic design company in India, delivering exceptional service at reasonable prices. Our team of talented and experienced designers specialize in crafting compelling and promotional packages to ensure your brand gets noticed globally.
                <br /><br />
                Looking for a captivating new logo, eye-catching podcast cover, or any other visual need? We've got you covered! Let's get started.
              </p>
              <button className="bg-[#f7a11f] text-black font-bold py-3 px-6 rounded-md uppercase hover:bg-[#e0901a] transition-colors duration-300">
                I Need Service
              </button>
            </div>
            <div className="w-full max-w-sm md:max-w-md lg:max-w-lg aspect-square bg-neutral-800 rounded-lg shadow-xl flex items-center justify-center p-4">
              <img src={HeroImg}  alt="Graphic designer working" className="w-full h-[100%] object-contain rounded-lg" />
            </div>
          </div>
        </div>
      </header>

      {/* Branding Section */}
      <section className="bg-white py-16 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-[#e0d8c7] via-[#f7f3ed] to-[#e0d8c7] py-4 px-6 rounded-lg shadow-md mb-8">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#333]">
              Elevate Your Brand with Engaging Graphic Design Services in India
            </h2>
          </div>
          <p className="max-w-4xl mx-auto leading-relaxed text-gray-700">
            At SRK Softwares, we specialize in captivating graphic design solutions tailored to elevate your brand's presence. As a leading graphic design company in India, our team comprises seasoned web and print designers dedicated to delivering top-notch results. From logos to social media motion graphics, our creators are skilled to magnify your audience effectively, conveying your key messages with clarity and artistry.
            <br /><br />
            With SRK Softwares, you're empowered with complete control over the design process. Choose your preferred design, set your budget, and provide feedback to our skilled graphic designers in India. Let's collaborate to bring your creative life and design vision to life or action.
          </p>
        </div>
      </section>

      {/* Help Cards Section */}
      <section className="bg-[#f7f7f7] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-[#e0d8c7] via-[#f7f3ed] to-[#e0d8c7] py-4 px-6 rounded-lg shadow-md mb-8">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#333]">How does graphic design help?</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <HelpCard icon="💡" title="Talking with Pictures" text="Graphic design is a bridge between you and your audience. It communicates your idea without saying a word, to everyone, no matter what their background is." />
            <HelpCard icon="🎯" title="Remembering Brands" text="Think of any brand, and the first thing you think of is their logo. Graphic design makes your brand easy to remember, so people remember you." />
            <HelpCard icon="✨" title="Cool Ads" text="Graphic design for your ads looks awesome, catches your eye and makes you want to know more about the product or service." />
            <HelpCard icon="💻" title="Easy Online Stuff" text="Websites and apps are all about making things simple. Graphic design helps you find what you need without getting confused." />
            <HelpCard icon="📖" title="Explaining Things" text="Complex information is hard to read. Graphic design makes it easy to understand with pictures and graphics. It's like telling a story visually." />
            <HelpCard icon="🌟" title="Being Creative" text="Graphic design is a great way for growing your business. It can be super creative and shows your vision so your client feels your original ideas." />
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-[#e0d8c7] via-[#f7f3ed] to-[#e0d8c7] py-4 px-6 rounded-lg shadow-md mb-8">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#333]">Our Graphic Design Services in India Include Some Process</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <ProcessStep src={Youtell} alt='you instruct for image' title="You Tell" text="You start by sharing your ideas, preferences, and requirements with us. Our team then gets to work to align with any visual project, we listen closely to understand your exact expectations." />
            <ProcessStep src={WeDesign} alt='we design' title="We Make" text="Our talented graphic designers bring your ideas to life. We craft designs that align with your vision and incorporate your feedback. Using our creativity and innovative approach, our designs resonate with your brand and message." />
            <ProcessStep src={Youapprove} alt='you approve' title="You Approve" text="We present the designs to you for approval. Your feedback matters, and we work collaboratively to ensure that you’re completely satisfied. Your approval marks the final step in bringing your vision and meets your expectations." />
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="bg-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-extrabold mb-4">Our Affordable Graphic Design Packages</h2>
          <p className="text-gray-400 max-w-2xl mx-auto mb-12">Choose a plan that's right for you. Our pricing is straightforward and designed to fit your budget.</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Basic Plan */}
            <PricingCard
              planName="Basic"
              price="₹199"
              period="per project"
              features={[
                '1-3 Design Concepts',
                '2 Revisions',
                '24/7 Support',
                'Standard Turnaround Time'
              ]}
              isFeatured={false}
            />
            {/* Pro Plan */}
            <PricingCard
              planName="Professional"
              price="₹499"
              period="per project"
              features={[
                '5+ Design Concepts',
                'Unlimited Revisions',
                'Priority Support',
                'Faster Turnaround Time',
                'Dedicated Project Manager'
              ]}
              isFeatured={true}
            />
            {/* Business Plan */}
            <PricingCard
              planName="Business"
              price="₹999"
              period="per project"
              features={[
                '10+ Design Concepts',
                'Unlimited Revisions',
                '24/7 Priority Support',
                'Dedicated Team',
                'Source Files Included',
                'Branding Guide'
              ]}
              isFeatured={false}
            />
          </div>
        </div>
      </section>
    </div>
    </Home>
  );
}

// Reusable Card Component
const HelpCard = ({ icon, title, text }) => (
  <div className="bg-white rounded-lg shadow-md p-6 flex flex-col items-center text-center transition-transform duration-200 hover:translate-y-[-5px] hover:shadow-lg">
    <div className="w-20 h-20 bg-gray-200 rounded-full mb-4 flex items-center justify-center text-3xl">
      {icon}
    </div>
    <h3 className="text-xl font-bold mb-2">{title}</h3>
    <p className="text-sm leading-relaxed text-gray-600">{text}</p>
  </div>
);

// Reusable Process Step Component
const ProcessStep = ({ title, text, src,alt }) => (
  <div className="flex flex-col items-center text-center">
    <div className="w-full max-w-xs aspect-[16/9] bg-gray-300 rounded-lg mb-4 flex items-center justify-center text-gray-500 font-medium">
      <img src={src} alt={alt} />
    </div>
    <h3 className="text-xl font-bold mb-2">{title}</h3>
    <p className="text-base leading-relaxed text-gray-700">{text}</p>
  </div>
);

// Reusable Pricing Card Component
const PricingCard = ({ planName, price, period, features, isFeatured }) => (
  <div className={`flex flex-col rounded-xl shadow-lg transform transition-transform duration-500 ease-in-out ${isFeatured ? 'bg-gradient-to-br from-yellow-500 to-orange-600 text-black scale-105' : 'bg-gray-800 text-white'}`}>
    <div className="p-8 text-center flex-grow">
      <h3 className={`text-2xl font-bold mb-2 ${isFeatured ? 'text-black' : 'text-yellow-400'}`}>{planName}</h3>
      <p className="text-4xl font-extrabold mb-1">{price}</p>
      <p className="text-sm text-gray-400 mb-6">{period}</p>
      <ul className="text-left space-y-3 mb-6">
        {features.map((feature, index) => (
          <li key={index} className={`flex items-start text-sm ${isFeatured ? 'text-gray-800' : 'text-gray-300'}`}>
            <svg className={`w-5 h-5 mr-2 flex-shrink-0 ${isFeatured ? 'text-black' : 'text-green-500'}`} fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            <span>{feature}</span>
          </li>
        ))}
      </ul>
    </div>
    <div className="p-8 pt-0">
      <button className={`w-full py-3 rounded-lg text-lg font-bold transition-colors duration-300 ${isFeatured ? 'bg-black text-white hover:bg-gray-900' : 'bg-yellow-500 text-black hover:bg-yellow-400'}`}>
        Choose Plan
      </button>
    </div>
  </div>
);


